function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import { buildService } from '@rd-web-markets/shared/dist/services/service';
import { useCallback, useEffect, useState } from 'react';
import * as QueryString from 'query-string';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
const api = buildService('/elsters/{id}/claim_project_reports', {
  only: ['all', 'get']
});
const elsterProjectsService = {
  useFetchAll: _ref => {
    let {
      accountType,
      elsterId,
      initialQueryParams = '',
      setLoading
    } = _ref;
    const history = useHistory();
    const location = useLocation();
    const [projects, setProjects] = useState([]);
    const [totalPages, setTotalPages] = useState(null);
    const [queryParams, setQueryParams] = useState(_objectSpread({}, QueryString.parse(location.search || initialQueryParams)));
    const fetchAllProjetcs = useErrorHandling(useCallback(async queryParams => {
      setLoading && setLoading(true);
      const projects = await api.all(elsterId, queryParams);
      setTotalPages(projects.pages);
      setProjects(projects);
      history.push({
        path: "".concat(accountType, "/elsters"),
        search: QueryString.stringify(queryParams)
      });
    }, [history, accountType, elsterId, setLoading]), useCallback(() => {
      setLoading && setLoading(false);
    }, [setLoading]));
    useEffect(() => {
      elsterId && fetchAllProjetcs(queryParams);
    }, [fetchAllProjetcs, queryParams, elsterId]);
    return [projects, setProjects, fetchAllProjetcs, totalPages, setTotalPages, queryParams, setQueryParams];
  },
  useGet: (elsterId, reportId) => {
    const [project, setProject] = useState(null);
    const fetchAndSetReport = useErrorHandling(useCallback(async () => {
      if (!elsterId || !reportId) return;
      const projectResponse = await api.get(elsterId, reportId);
      setProject(_objectSpread({}, projectResponse));
    }, [elsterId, reportId]));
    useEffect(() => {
      fetchAndSetReport();
    }, [fetchAndSetReport]);
    return [project, setProject, fetchAndSetReport];
  }
};
export default elsterProjectsService;